import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Button } from '../button'
import cn from 'classnames'
import * as React from 'react'
import { TopTitleBar } from '../top-title-bar'
import styles from './Window.module.css'
import { WindowProps, WindowRootProps } from './Window.types'

const Backdrop = () => <DialogPrimitive.Overlay className={styles.backdrop} />

function Window({ children, className, hasTitleBar = true, closeLabel, title, onCloseClick }: WindowProps) {
  return (
    <DialogPrimitive.Portal>
      <Backdrop />
      <div className={cn(styles.container)}>
        {hasTitleBar && (
          <TopTitleBar.Root>
            {title && <TopTitleBar.CenterArea title={title} />}
            {closeLabel && (
              <TopTitleBar.RightArea>
                <DialogPrimitive.Close asChild>
                  <Button
                    variant="transparentPrimary"
                    onClick={onCloseClick}
                  >
                    {closeLabel}
                  </Button>
                </DialogPrimitive.Close>
              </TopTitleBar.RightArea>
            )}
          </TopTitleBar.Root>
        )}
        <div className={cn(styles.content, className)}>
          {children}
        </div>
      </div>
    </DialogPrimitive.Portal>
  )
}

Window.displayName = 'Window'

Window.Root = ({ children, ...rest }: WindowRootProps) => (
  <DialogPrimitive.Root {...rest}>
    {children}
  </DialogPrimitive.Root>
)

Window.Trigger = ({ children }: React.PropsWithChildren) => (
  <DialogPrimitive.Trigger asChild>
    {children}
  </DialogPrimitive.Trigger>
)

export default Window
